"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Identifier = exports.decodeIdentifier = void 0;

var identifier_1 = require("./http/identifier");
/* {"domain":"comsel.device","key":"port.prefix","value":"a732243994670404","setAt":"2020-04-22T09:53:45Z"} */


exports.decodeIdentifier = function (i) {
  if (i == null) {
    console.log("decodeIdentifier called with null value");
    return new Identifier("", "");
  }

  return new Identifier(i.domain, i.key, i.value, new Date(i.setAt));
};

var Identifier =
/** @class */
function () {
  function Identifier(domain, key, value, setAt) {
    this.domain = domain;
    this.key = key;

    if (value != null) {
      this.value = value;
    } else {
      this.value = "";
    }

    if (setAt != null) {
      this.setAt = setAt;
    } else {
      this.setAt = new Date(0);
    }
  }

  Identifier.prototype.get = function (uuid, credentials) {
    var _this = this;

    return identifier_1.get(credentials, uuid, this.domain, this.key).then(function (ret) {
      var id = exports.decodeIdentifier(ret);

      if (id.value.length > 0) {
        _this.value = id.value;
      }

      if (id.setAt.getTime() > 0) {
        _this.setAt = id.setAt;
      }

      return id;
    });
  };

  return Identifier;
}();

exports.Identifier = Identifier;